export default {
  namespaced: true,
  billing_holiday: {
    title: "Días festivos",
    date: "Fecha",
  }
}